import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { Assessment } from "@/core/types";

import { useAssessmentKey } from "../keyFactory";
import { getDefinition } from "../queryFunctions/getDefinition";

type GetAssessmentDefinitionprops = {
  id: string;
  options?: Omit<UseQueryOptions<Assessment>, "queryFn" | "queryKey">;
};

export function useAssessmentDefinition({ id, options }: GetAssessmentDefinitionprops) {
  return useQuery({
    queryFn: () => getDefinition({ id }),
    queryKey: useAssessmentKey.detail(id),
    staleTime: 30 * 60 * 1000, // 30 min - definitions rarely change
    ...options,
  });
}
